const state = {
    user: null,
};
const mutations = {
    setUser(state, userInfo){
        state.user = userInfo
    },
};
const actions = {
    setUser({commit}, userInfo){
        commit('setUser', userInfo);
    },
};
const getters = {
    user(state){
        return state.user
    },
};

export default {
    namespaced:true,
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/adminUser.js